import { jsxs as s, jsx as o } from "react/jsx-runtime";
import { LoadingGif as l } from "../../icons/index.js";
import '../../../assets/index4.css';const i = "_button_g4r11_1", u = "_button__primary_g4r11_22", c = "_button__secondary_g4r11_32", a = "_button__neutral_g4r11_43", d = "_button__link_g4r11_53", y = "_button__icon_g4r11_54", r = {
  button: i,
  button__primary: u,
  button__secondary: c,
  button__neutral: a,
  button__link: d,
  button__icon: y
};
function p(t) {
  const e = t.styleType || "primary", _ = t.loading || !1, b = t.tip || null, n = { ...t };
  return delete n.styleType, delete n.loading, delete n.tip, /* @__PURE__ */ s(
    "button",
    {
      ...n,
      type: e == "icon" ? "button" : n.type,
      disabled: _,
      className: `${t.className || ""}${e ? ` ${r["button__" + e]} ${e === "link" ? "underline md:b-text-nowrap" : ""}` : ""} ${r.button} b-text-sm`,
      children: [
        b && /* @__PURE__ */ o("span", { className: "b-absolute -b-top-1 b-left-1/2 b-bg-red-600 b-text-white b-border-2 b-border-gray-200 b-px-1 b-py-[2px] b-text-xs b-rounded-full", children: b }),
        _ ? /* @__PURE__ */ o("div", { className: "b-flex b-items-center b-justify-center", children: /* @__PURE__ */ o("img", { className: "b-w-5 b-h-5", src: l }) }) : t.children
      ]
    }
  );
}
const x = (t) => /* @__PURE__ */ o("a", { ...t });
export {
  p as Button,
  x as Link
};
